module.exports = __webpack_public_path__ + "img/bf_pmgw_2-small_transparent.019b7622.png";